import { BlurIcon } from './BlurIcon';

/**
 * author: Google
 * id FAFCB184-2AAD-4E83-924F-1C37F1EDF956
 * name blur
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/blur.svg
 * tags
 */
export const BlurOnIcon = BlurIcon;
export default BlurOnIcon